import styled from 'styled-components';

export const TabsContainer = styled.div`
  display: flex;
  align-items: stretch;
  margin-bottom: 28px;
  border-bottom: 2px solid #363636;
`;

export const TabButton = styled.button`
  flex: 1;
  font-family: 'Roboto', sans-serif;
  font-size: 15px;
  font-weight: 600;
  padding: 12px 0;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.2s ease;
  position: relative;

  ${({ active }) =>
    active
      ? `
    color: #fff;

    &::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 100%;
      height: 2px;
      background: linear-gradient(251.45deg, #f5134b 1.26%, #f34d21 96.99%);
    }
  `
      : `
    color: #828282;

    &:hover {
      color: #fff;
    }
  `}

  & + & {
    border-left: 2px solid #363636;
  }
`;

export const MonthSelectWrapper = styled.div`
  margin-bottom: 20px;

  select {
    background: #222222;
    color: #ffffff;
    border: 2px solid #363636;
    border-radius: 10px;
    padding: 8px 36px 8px 16px;
    font-size: 14px;
    font-family: 'Roboto', sans-serif;
    cursor: pointer;
    outline: none;
    transition: border-color 0.2s;
    appearance: none;
    -webkit-appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23828282' stroke-width='1.8' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;

    &:hover,
    &:focus {
      border-color: #f34d21;
    }

    option {
      background: #222222;
      color: #ffffff;
    }
  }
`;

export const BackgroundSection = styled.section`
  font-family: 'roboto';
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 50px 100px;

  @media (max-width: 700px) {
    margin: 50px;
  }

  h1 {
    color: #ffffff;
    font-size: 35px;
  }

  h2 {
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 20px;
  }

  @media (max-width: 450px) {
    h1, h2 {
      font-size: 20px;
      margin: auto;
      margin-bottom: 20px;
    }

    h2 {
      font-size: 14px;
    }
  }

  div.notRanking {
    max-width: 670px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    text-align: center;
    margin: 70px auto;

    svg {
      width: 400px;
      height: 270px;

      @media (max-width: 450px) {
        width: 100%;
        height: 100%;
      }
    }

    span {
      color: #fff;
      font-size: 30px;
      padding: 30px 0;
      max-width: 500px;
      font-family: 'UniviaRegular';

      @media (max-width: 450px) {
        font-size: 20px;
      }
    }

    a {
      font-family: 'Roboto', sans-serif;
      color: #fafafa;
      font-size: 17px;
      background: linear-gradient(251.45deg, #f5134b 1.26%, #f34d21 96.99%);
      border-radius: 15px;
      outline: none;
      border: 0;
      padding: 0.5rem 3rem;

      &:hover {
        cursor: pointer;
        box-shadow: 0 0 2px 2px #f34d21;
      }
    }
  }

  table {
    font-size: 16px;

    tbody {
      color: #ffffff;

      tr {
        margin-top: 20px;
        background: #222222;
        border-radius: 5px;

        border-width: 2px;
        border-style: solid;
        border-color: #363636;

        display: flex;
        justify-content: space-between;
        align-items: center;

        td {
          display: flex;
          align-items: center;
          div.name-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          img {
            width: 64px;
            height: 64px;
            border-radius: 50%;
            margin: 0 20px 0 5px;
            object-fit: cover;
            cursor: pointer;
          }

          @media (max-width: 540px) {
            img {
              display: none;
            }
          }
        }

      }
      @media (min-width: 400px) and (max-width: 450px) {
        tr {
          width: 330px;
          margin: 20px auto 0;
        }
      }
      @media (max-width: 400px) {
        tr {
          width: 280px;
          margin: 20px auto 0;
        }
      }

      tr td span.names {
        color: #ffffff;
        font-size: 16px;
        font {
          font-size: 12px;
          color: #828282;

          @media (max-width: 400px) {
            display: none;
          }
        }
      }
      tr td span.orange {
        color: #fe5812;
        font-size: 18px;
      }
      tr td span.grey {
        color: #828282;
        font-size: 13px;
        margin: 0 10px;
        cursor: help;
      }
    }
  }
`;

export const EllipsisContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .ellipsis-dot {
    width: 10px;
    height: 10px;
    background: linear-gradient(251.45deg, #f5134b 1.26%, #f34d21 96.99%);
    border-radius: 50%;
    margin: 10px 10px 5px;
  }
`;

export const NotScoredMessage = styled.div`
  color: #828282;
  font-size: 15px;
  text-align: center;
  padding: 20px 16px;
  border: 1px solid #363636;
  border-radius: 8px;
  background: #222222;
  margin-top: 16px;
`;

export const BothRankingsNote = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: #f34d21;
  margin-top: 2px;
  line-height: 1.2;
`;

export const CrossedPosition = styled.span`
  color: #828282;
  font-size: 18px;
  text-decoration: line-through;
  opacity: 0.6;
`;
